<div>
  <div mat-icon-button [matMenuTriggerFor]="appmenu" style="padding-top: 9px; margin-right: 15px; cursor: pointer; color: white">
    <mat-icon>apps</mat-icon>
    <!-- <img src="assets/images/nine-dots.svg" alt="CatchHub"> -->
  </div>
  <mat-menu #appmenu="matMenu" class="app-menu-panel" [overlapTrigger]="false" style="color: white">
    <div style="display: flex; flex-wrap: wrap">
      @for (icon of appIconList; track icon) {
      <app-toolbar-app-menu-icon [labelText]="icon.label" [iconSource]="icon.url" [base64String]="icon.base64String" [appModel]="icon.appModel"> </app-toolbar-app-menu-icon>
      }
    </div>
  </mat-menu>
</div>
